import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { en, ko } from './languages';

export const resources = { en, ko };

i18next.use(initReactI18next)
       .use(LanguageDetector)
       .init({
         resources,
         debug: true,
         fallbackLng: 'ko',
         interpolation: {
           escapeValue: false,
         },
       });

export default i18next;